const FieldMaxLengths = Object.freeze({
    PHONE: 15,
    NAME: 100,
});

export default FieldMaxLengths;
